import { createBrowserHistory } from 'history';
import ReactDOM from 'react-dom';
import { BrowserRouter } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { RecoilRoot } from 'recoil';
import { App } from './App';
import { CoreInterceptors } from './Component/Api/AxiosCoreInterceptor';
import { Interceptors } from './Component/Api/AxiosInterceptor';
import { WSPInterceptors } from './Component/Api/AxiosWSPInterceptor';
import { MaterialUIControllerProvider } from './Context';
import { UnsecuredPage } from './UnsecuredPage';
import config from './config';
import reportWebVitals from './reportWebVitals';

import { ApplicationInsights } from '@microsoft/applicationinsights-web';
import { AppInsightsContext, ReactPlugin } from '@microsoft/applicationinsights-react-js';
import { ReactNode } from "react";

let applicationStack : ReactNode;
if (window.self === window.top) {
  applicationStack = (
    <RecoilRoot>
      <BrowserRouter basename={config.mainUrl}>
        <MaterialUIControllerProvider>
          <ToastContainer />
          <App />
        </MaterialUIControllerProvider>
      </BrowserRouter>
    </RecoilRoot>
  );
} else {
  applicationStack = <UnsecuredPage />
}

export const history = createBrowserHistory();

// Initialise Application Insights.
const appInsightsConnectionString = config.appInsightsConnectionString;
if (appInsightsConnectionString !== null && appInsightsConnectionString !== undefined && appInsightsConnectionString !== "") {
  const reactPlugin = new ReactPlugin();
  const appInsights = new ApplicationInsights({
    config: {
      connectionString: appInsightsConnectionString,
      extensions: [reactPlugin],
      extensionConfig: {
        [reactPlugin.identifier]: { history }
      }
    }
  });
  appInsights.loadAppInsights();
  applicationStack = (
    <AppInsightsContext.Provider value={reactPlugin}>
      {applicationStack}
    </AppInsightsContext.Provider>);
}

Interceptors.setupTokenInterceptor();
CoreInterceptors.setupCoreTokenInterceptor();
WSPInterceptors.setupCoreTokenInterceptor();

ReactDOM.render(<>{applicationStack}</>, document.getElementById('root'));

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
